import { useEffect } from 'react';

const SCROLL_REGION_SELECTOR = 'main, [data-scroll-region]';

let lockCount = 0;
let restore = [];

function lockElement(element) {
  const { overflow, scrollbarGutter } = element.style;
  element.style.overflow = 'hidden';
  // Keep the gutter so the content does not shift sideways when the bar hides.
  element.style.scrollbarGutter = 'stable';
  return () => {
    element.style.overflow = overflow;
    element.style.scrollbarGutter = scrollbarGutter;
  };
}

function acquire() {
  lockCount += 1;
  if (lockCount > 1) return;
  const targets = [document.documentElement, document.body, ...document.querySelectorAll(SCROLL_REGION_SELECTOR)];
  restore = targets.map(lockElement);
}

function release() {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount > 0) return;
  restore.forEach((fn) => fn());
  restore = [];
}

/**
 * Freezes the page behind an overlay (modal, drawer) while it is open.
 *
 * The workspace shells scroll inside `<main>`, not the window, so locking
 * `document.body` alone is not enough; every scroll region is frozen and
 * restored exactly as it was when the last overlay closes. Locks are
 * reference-counted so stacked overlays release cleanly.
 */
export function useScrollLock(active) {
  useEffect(() => {
    if (!active) return undefined;
    acquire();
    return release;
  }, [active]);
}
